<template>
    <panel-modal ref="popup" @close="close">
        
        <SignalInner :signal_id="signal_id" :house_id="house_id" :organization_id="organization_id" @createTask="()=>{ $emit('createTask'); }"/>
        
    </panel-modal>
</template>

<script>

    import PanelModal from './PanelModal.vue'
    import SignalInner from '../signals/SignalInner.vue'

    export default {

        name: 'PanelTask',

        components: { PanelModal, SignalInner },

        emits: ['createTask', 'close'],

        data: () => ({
            signal_id: null,
            house_id: null,
            organization_id: null,
        }),

        methods: {
            close () {
                this.$refs.popup.close();
                if(this.$route.name == 'PageTrackerHouseSignals') {
                    history.pushState({}, null, this.$route.path);
                }
                if(this.$route.name == 'PageTrackerHouseSignal') {
                    this.$router.push({name: 'PageTrackerHouseSignals', params: {organization_id: this.organization_id, house_id: this.house_id}});
                }
                this.$emit('close');
            },
            show(opts = {}) {

                this.signal_id = opts.signal_id;
                this.house_id = opts.house_id;
                this.organization_id = opts.organization_id;

                this.$refs.popup.open();

                if(this.$route.name == 'PageTrackerHouseSignals') {
                    history.pushState({}, null, this.$route.path + '/' + this.signal_id);
                }
            },
        },
    }
</script>

<style scoped>

</style>